import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Taxon } from '../domain/Analyse/taxon';
import { Taxon as IBMRTaxon } from '../domain/IBMR/IBMR-taxon';
import { CoreData } from '../tools/core-data';
import { LoadingTask } from '../tools/loading-task';
import { BaseService } from './base-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TaxonSplitDTO } from './DTO/taxon-split.dto';

@Injectable({
    providedIn: 'root',
})
export class TaxonService extends BaseService {
    private serviceUrl = `${environment.serviceMainBaseUrl}api/taxon`;

    constructor(protected http: HttpClient,
        protected coreData: CoreData,
        protected loadingTask: LoadingTask,
        protected snackBare: MatSnackBar,
        protected router: Router,
    ) {
        super(coreData, router, snackBare);
    }

    create(taxon: Taxon, analyseCode: string) {
        this.loadingTask.activateLoading();
        let body = Object.assign({}, taxon);
        body.AnalyseCode = analyseCode;
        return this.http.post(`${this.serviceUrl}`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('createTaxon')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    updateTaxonForCyano(analyseCode: string, taxon: Taxon) {
        this.loadingTask.activateLoading();
        let body = {
            AnalyseCode: analyseCode,
            NomGenre: taxon.NomGenre,
            Quantite: taxon.Quantite,
            Colonie: taxon.Colonie
        };
        return this.http.put(`${this.serviceUrl}/cyano`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateTaxonForCyano')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    undoLastTaxonCountForCyano(taxon: Taxon) {
        this.loadingTask.activateLoading();

        return this.http.put(`${this.serviceUrl}/cyano/${taxon.Code}/undo`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('undoLastTaxonCountForCyano')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    delete(analyseCode: string, codeSANDRE: number, i: number) {
        this.loadingTask.activateLoading();

        return this.http.delete(`${this.serviceUrl}/${analyseCode}/${codeSANDRE}/${i}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteTaxon')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    deleteTaxonByCode(taxonCode: string) {
        this.loadingTask.activateLoading();

        return this.http.delete(`${this.serviceUrl}/${taxonCode}/`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteTaxonByCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    deleteWithTransect(analyseCode: string, codeSANDRE: number, i: number, transect: number) {
        this.loadingTask.activateLoading();

        return this.http.delete(`${this.serviceUrl}/${analyseCode}/${codeSANDRE}/${i}/${(transect - 1) % 10 + 1}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteWithTransect')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }

    split(customName: string, analyseCode: string, destinationTaxonList: IBMRTaxon[]) {
        this.loadingTask.activateLoading();
        let body = new TaxonSplitDTO()
        body.AnalyseCode = analyseCode;
        body.CustomName = customName;
        body.DestinationTaxonList = destinationTaxonList

        return this.http.post(`${this.serviceUrl}/split`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('split')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}